/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Th3Inputs */

const en_mk_cmp_notion_th3 = /** @type {(inputs: Mk_Cmp_Notion_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Agent credits are billed separately on top of the plan.`)
};

const id_mk_cmp_notion_th3 = /** @type {(inputs: Mk_Cmp_Notion_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredit Custom Agents ditagih terpisah di atas paket.`)
};

/**
* | output |
* | --- |
* | "Custom Agent credits are billed separately on top of the plan." |
*
* @param {Mk_Cmp_Notion_Th3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_th3 = /** @type {((inputs?: Mk_Cmp_Notion_Th3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Th3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_th3(inputs)
	return en_mk_cmp_notion_th3(inputs)
});